"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Slider = require("./Slider.styles");

var _Slider2 = _interopRequireDefault(require("./Slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BuildSlider = function BuildSlider(_ref) {
  var children = _ref.children,
      data = _ref.data,
      width = _ref.width,
      height = _ref.height,
      leftArrowComponent = _ref.leftArrowComponent,
      rightArrowComponent = _ref.rightArrowComponent,
      props = _objectWithoutProperties(_ref, ["children", "data", "width", "height", "leftArrowComponent", "rightArrowComponent"]);

  return _react.default.createElement(_Slider.SliderWrapper, {
    height: height,
    width: width,
    "data-qa-node": "SliderWrapper"
  }, _react.default.createElement(_Slider.SliderContent, {
    isDots: props.showDots,
    "data-qa-node": "SliderContent"
  }, _react.default.createElement(_Slider2.default, _extends({
    slides: data
  }, props, {
    "data-qa-node": "Slider"
  }), _react.default.createElement(_Slider2.default.LeftArrow, null, leftArrowComponent), _react.default.createElement(_Slider2.default.Content, null), _react.default.createElement(_Slider2.default.RightArrow, null, rightArrowComponent), _react.default.createElement(_Slider2.default.Dots, null))));
};

BuildSlider.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  data: _propTypes.default.arrayOf(_propTypes.default.object),
  showDots: _propTypes.default.bool,
  leftArrowComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  rightArrowComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
BuildSlider.defaultProps = {
  width: '100%',
  height: '100%',
  data: null,
  showDots: true,
  leftArrowComponent: '<',
  rightArrowComponent: '>'
};
var _default = BuildSlider;
exports.default = _default;